var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#49A4AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.364 10.476L11.352 15.012H10.632L10.344 13.944C9.66 14.784 8.736 15.216 7.584 15.216C6.372 15.216 5.388 14.808 4.644 13.992C3.9 13.176 3.528 12.12 3.528 10.812C3.528 9.504 3.888 8.424 4.632 7.572C5.376 6.708 6.384 6.288 7.68 6.288C8.268 6.288 8.82 6.384 9.336 6.588C9.84 6.792 10.284 7.116 10.644 7.548C11.004 7.98 11.208 8.496 11.256 9.084H10.152C10.056 8.532 9.792 8.076 9.336 7.74C8.88 7.404 8.328 7.224 7.668 7.224C6.744 7.224 6.012 7.548 5.472 8.184C4.92 8.82 4.656 9.684 4.656 10.764C4.656 11.844 4.92 12.696 5.472 13.32C6.012 13.956 6.744 14.268 7.668 14.268C8.532 14.268 9.18 14.016 9.636 13.488C10.092 12.96 10.332 12.264 10.356 11.4H7.62V10.476H11.364ZM19.8215 6.456V15H18.6935V11.004H14.1815V15H13.0535V6.456H14.1815V10.02H18.6935V6.456H19.8215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login_logo.8a57d5797b5b5c943d963fa46856f820.svg";
export { ForwardRef as ReactComponent };